import React from "react";
import { Phone, Mail, Clock } from "lucide-react";

const ContactForm = ({
  formData,
  handleInputChange,
  handleFormSubmit,
  slug,
}) => {
  return (
    <div className="sticky max-w-md p-6 bg-white border border-gray-100 shadow-2xl top-24 rounded-2xl">
      <div className="p-4 mb-4 text-white bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl">
        <h3 className="text-xl font-bold">Get Expert Help</h3>
        <p className="text-sm text-blue-100">
          Connect with our CA professionals
        </p>
      </div>
      <form onSubmit={handleFormSubmit} className="space-y-4">
        <div>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Full Name"
            required
          />
        </div>

        <div>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Email Address"
            required
          />
        </div>

        <div>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Phone Number"
            required
          />
        </div>

        <div>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            rows="2"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Tell us about your requirements..."
          ></textarea>
        </div>

        <button
          type="submit"
          className="w-full px-4 py-2 text-sm font-medium text-white transition-all transform rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 hover:scale-105"
        >
          Send Details
        </button>
      </form>
      <div className="pt-4 mt-4 border-t border-gray-200">
        <div className="flex items-center mb-2 space-x-2">
          <Phone className="w-4 h-4 text-blue-600" />
          <p>
            <a
              href="tel:+917673040500"
              className="block text-sm text-gray-700 transition-colors hover:text-yellow-400"
            >
              +91 7673040500
            </a>

            <a
              href="tel:+919334743600"
              className="block text-sm text-gray-700 transition-colors hover:text-yellow-400"
            >
              +91 9934743600
            </a>
          </p>
        </div>
        <div className="flex items-center mb-2 space-x-2">
          <Mail className="w-4 h-4 text-blue-600" />
          <a
            href="mailto:govind@cagovindsinha.com"
            className="text-sm text-gray-700 transition-colors hover:text-yellow-400"
          >
            govind@cagovindsinha.com
          </a>
        </div>
        <div className="flex items-center space-x-2">
          <Clock className="w-4 h-4 text-blue-600" />
          <span className="text-sm text-gray-700">Mon-Sat: 10:30AM-7PM</span>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
